<template>
  <div class="logincontainer">
    <div class="loginlogo">
      <img :src="loginlogo" alt="">
    </div>

    <el-form ref="loginform" :model="dataForm" :rules="datarules" label-position="top" style="width: 100%;">

      <el-form-item class="phone pubpadding" prop="phoneNumber">
        <span><i></i>手机号</span>
        <el-input v-model="dataForm.phoneNumber" @blur.prevent="blurFun()"/>
      </el-form-item>
      <el-form-item class="code pubpadding"  prop="authCode">
        <span><i></i>验证码</span>
        <p v-show="verShow" @click="getauthcode">获取验证码</p>
        <p v-show="!verShow"><i>{{timer}}</i>秒重新获取</p>
        <el-input v-model="dataForm.authCode" @blur.prevent="blurFun()"/>
      </el-form-item>
    </el-form>
    <div class="loginconfirm" ref="loginconfirm">
      <a href="javascript:;" class="qd" @click="loginconfirm()">确定</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        // console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      dataForm: {
        phoneNumber: '',
        authCode: ''
      },
      datarules: {
        phoneNumber: [{required: true, message: '请输入正确的手机号', validator: checkPhone, trigger: 'blur'}],
        authCode: [{required: true, message: '请输入验证码', trigger: 'blur'}]
      },
      verShow: true,
      timer: 60,
      timers: null,
      loginlogo: require('../assets/images/icon-logintitle.png'),
      normallogo: require('../assets/images/icon-logintitle.png'),
      lslogo: require('../assets/images/ls_logo.png')
    }
  },
  mounted () {
    if (this.$route.query.theme !== undefined && this.$route.query.theme === 'ls') {
      this.loginlogo = this.lslogo
    } else {
      this.loginlogo = this.normallogo
    }
  },
  methods: {
    // 获取验证码
    getauthcode () {
      if (this.dataForm.phoneNumber !== '') {
        this.verShow = false
        let authtimer = setInterval(() => {
          this.timer--
          if (this.timer <= 0) {
            this.verShow = true
            this.timer = 60
            clearInterval(authtimer)
          }
        }, 1000)
        this.$http({
          url: this.$http.adornUrl(`/api/message/send/verification-code?phoneNumber=` + this.dataForm.phoneNumber),
          method: 'get'
        }).then((res) => {
          if (res) {
            if (res.status === 200) {
              this.$message({message: '验证码发送成功', type: 'success'})
            } else {
              this.$message.error(res.data)
            }
          } else {
            this.$message.error(res.data)
          }
        })
      } else {
        this.tip('请填写手机号', '150', '40')
      }
    },
    // 登录
    loginconfirm () {
      this.$refs['loginform'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/api/auth/jwt/member-token`),
            method: 'post',
            data: this.$http.adornData({
              'mobilePhone': this.dataForm.phoneNumber,
              'authCode': this.dataForm.authCode
            })
          }).then((res) => {
            if (res) {
              if (res.status === 200) {
                this.$cookie.set('token', res.data)
                this.timers = setInterval(() => {
                  if (this.$cookie.get('typeflag') === 'false') {
                    this.$router.push({path: '/message', query: {museumCode: this.$cookie.get('museumCode'), typeflag: 1, theme: this.$cookie.get('themeName')}})
                  } else {
                    this.$router.push({path: '/message', query: {museumCode: this.$cookie.get('museumCode'), theme: this.$cookie.get('themeName')}})
                  }
                }, 200)
              } else {
                this.$message.error(res.data)
              }
            } else {
              this.$message.error(res.data)
            }
          })
        }
      })
    },
    blurFun () {
      setTimeout(function () {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 300)
    }
  },
  beforeDestroy () {
    clearInterval(this.timers)
    this.timers = null
  }
}
</script>

<style lang="scss">
.logincontainer{
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 0 40%;
  .loginlogo{
    width: 20%;
    margin: 50% auto 12%;
    img{
      width: 100%;
    }
  }
  .loginconfirm{
    text-align: center;
    padding: 50px 0 0;
    a{
      display: inline-block;
      background: #a11b00;
      color:#fff;
      width: 50%;
      border-radius: 8px;
      height: 40px;
      line-height: 40px;
      margin: 0 20px;
      font-size: 16px;
      letter-spacing: 4px;
    }
  }
  .el-form-item{
    background: #fff;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    position: relative;
    margin-bottom: 30px;
    span{
      position: absolute;
      width: 180px;
      left: 0;
      top: 0;
      display: inline-block;
      letter-spacing: 5px;
      font-size: 16px;
      i{
        display: inline-block;
        vertical-align: middle;
        margin: 0 10px 0 15px;
        width: 20px;
        height: 18px;
      }
    }
    .el-input{
      margin-left: 108px;
      width: 50%;
      z-index: 10;
      input {
        width: 100%;
        display: inline-block;
        border: none;
        outline: none;
        padding: 0 10px;
      }
    }
    &.phone{
      span{
        i{
          background: url(../assets/images/icon-tel.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    &.code{
      span{
        i{
          background: url(../assets/images/icon-card.png) no-repeat;
          background-size: 100% 100%;
        }
      }
      p{
        position: absolute;
        z-index: 2;
        height: 24px;
        line-height: 26px;
        padding: 0 15px;
        right: 10px;
        letter-spacing: 2px;
        top: 8px;
        background: #c5c5c5;
        color: #fff;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        text-align: center;
        font-size: 12px;
        z-index: 22;
        i{

        }
        @media screen and ( max-width:320px) {
          padding: 0 5px;
          right: 10px;
          letter-spacing: 0px;
        }
      }
    }
  }
}

@media only screen and ( max-width:1440px) {
  .logincontainer{
    padding: 0 35%;
    .loginlogo{
      margin-top: 34%;
    }
  }
}
@media only screen and ( max-width:768px) {
  .logincontainer{
    padding: 30px;
    .loginlogo{
      margin-top: 14%;
    }
  }
}
.lstheme{
  .logincontainer{
    .el-form-item{
      background: #012245;
      border: solid 1px #9fb9d0;
      box-shadow: 0 0 40px rgba(171, 222, 254, 0.5) inset;
      span{
        color: #fff;
      }
      .el-input__inner{
        background: none;
        color: #bfd2f0;
      }
      &.code{
        p{
          background: #5297f2;
        }
        span{
          i{
            background: url(../assets/images/icon_ls_tel.png) no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      &.phone{
        span{
          i{
            background: url(../assets/images/icon_ls_card.png) no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    .loginconfirm {
      a{
        border: solid 2px #5297f2;
        border-radius: 20px;
        background: -webkit-linear-gradient(top, #fefefe , #7cbbee);
        background: -o-linear-gradient(bottom, #fefefe, #7cbbee);
        background: -moz-linear-gradient(bottom, #fefefe, #7cbbee);
        background: linear-gradient(to bottom, #fefefe , #7cbbee);
        filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#fefefe, endColorstr=#7cbbee);
        color: #123764;
      }
    }
  }
  .el-form-item__error{
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue